/**
 * Google Analytics Helper
 */

/**
 * Remove empty attributes from an object
 */
function removeEmpty(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
}

/**
 * Send a Custom Event to Google Analytics
 */
export function gaEvent({
  event = null,
  label = null, // optional
}, send = true) {
  if (!send) {
    console.error('Analytics: event cancelled, send parameter is false');
  }

  const data = removeEmpty({
    label,
  });

  console.log('Analytics Event:', event, data);

  // send custom event
  window.dataLayer.push({
    event,
    ...data,
  });
}

export default {
  gaEvent,
};